<div class="hint-wrapper">
    <span class="clickable-text mtv-primary-color" (click)="toggle()">{{data.name}}</span>

    <div class="hint" [ngClass]="{'up': isDirectionTop, 'active': isShow}">
        <div class="hint-content">
            <div class="logo" *ngIf="data.logo">
                <img [src]="data.logo">
            </div>
            <hr>
            <div class="m-b-xs">
                <span class="strong m-r-sm">COLOR THEME</span>
                <span class="item-name">{{data.name}}</span>
            </div>
            <hr>
            <div class="m-b-xs color-item">
                <div class="color-view" [style.background]="data.colors.body"></div>
                <span class="strong">Background color</span>
            </div>
            <div class="m-b-xs color-item">
                <div class="color-view" [style.background]="data.colors.primary"></div>
                <span class="strong">Primary color</span>
            </div>
            <div class="m-b-xs color-item">
                <div class="color-view" [style.background]="data.colors.primaryHover"></div>
                <span class="strong">Primary hover color</span>
            </div>
            <div class="m-b-xs color-item">
                <div class="color-view" [style.background]="data.colors.secondary"></div>
                <span class="strong">Secondary color</span>
            </div>
            <div class="m-b-xs color-item">
                <div class="color-view" [style.background]="data.colors.menuBackgroundColor"></div>
                <span class="strong">Menu Background Color</span>
            </div>
            <div class="m-b-xs color-item">
                <div class="color-view" [style.background]="data.colors.menuFontColor"></div>
                <span class="strong">Menu Font Color</span>
            </div>
            <div class="m-b-xs color-item">
                <div class="color-view" [style.background]="data.colors.selectedMenuItemFontColor"></div>
                <span class="strong">Selected Menu Item Font Color</span>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/themes/hint/hint.component.html